import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { AddressForm } from './address-form';
import { ContactForm } from './contact-form';

export class SiteForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  siteKey: FormControl<string | undefined>;
  legalName: FormControl<string | null>;
  units: FormControl<number | null>;
  dba: FormControl<string | null>;
  structure: FormControl<string | null>;
  ein: FormControl<string | null>;
  ssn: FormControl<string | null>;
  bsn: FormControl<string | null>;
  latitude: FormControl<string | null>;
  longitude: FormControl<string | null>;
  phone: FormControl<string | null>;
  phoneExt: FormControl<string | null>;
  fax: FormControl<string | null>;
  website: FormControl<string | null>;
  logo: FormControl<string | null>;
  status: FormControl<'Active' | 'Deactivated' | null>;
  apiSource: FormControl<string | null>;
  apiKey: FormControl<string | null>;
  siteType: FormControl<string | null>;

  StreetAddress: AddressForm;
  MailingAddress: AddressForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      siteKey: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      legalName: new FormControl<string | null>(null),
      units: new FormControl<number | null>(null),
      dba: new FormControl<string | null>(null),
      structure: new FormControl<string | null>(null),
      ein: new FormControl<string | null>(null),
      ssn: new FormControl<string | null>(null),
      bsn: new FormControl<string | null>(null),
      latitude: new FormControl<string | null>(null),
      longitude: new FormControl<string | null>(null),
      phone: new FormControl<string | null>(null),
      phoneExt: new FormControl<string | null>(null),
      fax: new FormControl<string | null>(null),
      website: new FormControl<string | null>(null),
      logo: new FormControl<string | null>(null),
      status: new FormControl<'Active' | 'Deactivated' | null>(null),
      apiSource: new FormControl<string | null>(null),
      apiKey: new FormControl<string | null>(null),
      siteType: new FormControl<string | null>(null),

      StreetAddress: new AddressForm(),
      MailingAddress: new AddressForm()
    });
  }
}
